module.exports = __webpack_public_path__ + "media/hyper/images/users/avatar-1-9232d94e0e75754e115653e1dafeb3c5.jpg";